import { getAddressComponentType } from './getters';

//ADDRESSES
export const mapGplaceFormattedLocationToConvelioPricingApiAddressType = (
  formatted_location = {}
) => {
  const { address_components, formatted_address, geometry } =
    formatted_location;
  return {
    postal_code: getAddressComponentType(address_components, 'postal_code')
      ?.long_name,
    city: getAddressComponentType(address_components, 'locality')?.long_name,
    countryCode:
      getAddressComponentType(address_components, 'country')?.short_name ||
      'NA',
    country: getAddressComponentType(address_components, 'country')?.long_name,
    street: formatted_address,
    state: getAddressComponentType(
      address_components,
      'administrative_area_level_1'
    )?.long_name,
    lat: geometry?.location?.lat,
    lng: geometry?.location?.lng
  };
};
